import { CSSProperties } from 'react';
import { useMemo } from 'react';

import { CustomCSSProperties } from '../model';

export const useImageBorderStyles = (borderRadius?: (string | undefined)[] /* top, right, bottom left */, key?: string) => {
  const baseKey = useMemo(() => key ?? '--image-viewer-border-radius', [key]);

  const containerStyle = useMemo(() => {
    const borderRadiiLength = borderRadius ? borderRadius.length : 0;
    const dict: CustomCSSProperties = {};

    if (borderRadius && borderRadiiLength > 0) {
      const isSingleRadius = borderRadiiLength === 1;
      if (!isSingleRadius && borderRadiiLength !== 4) {
        console.error(`Cannot assign border radius. Need 4 values`);
      }

      const topLeft = borderRadius[0];
      const topRight = isSingleRadius ? topLeft : borderRadius[1];
      const bottomRight = isSingleRadius ? topLeft : borderRadius[2];
      const bottomLeft = isSingleRadius ? topLeft : borderRadius[3];

      if (topLeft !== undefined) {
        dict[`${baseKey}-top-left`] = topLeft;
      }
      if (topRight !== undefined) {
        dict[`${baseKey}-top-right`] = topRight;
      }
      if (bottomRight !== undefined) {
        dict[`${baseKey}-bottom-right`] = bottomRight;
      }
      if (bottomLeft !== undefined) {
        dict[`${baseKey}-bottom-left`] = bottomLeft;
      }
    }
    return dict as CSSProperties;
  }, [baseKey, borderRadius]);

  return containerStyle;
};
